interface TriangleUpProps {
  active?: boolean
}

export function TriangleUp({ active = false }: TriangleUpProps): JSX.Element {
  return (
    <svg
      width="9"
      height="6.5"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="triangleUp"
    >
      <path d="M5 0.75L8.75 6.25H1.25L5 0.75Z" className={`fill-svgColor ${active ? 'opacity-100' : 'opacity-40'}`} />
    </svg>
  )
}
